module.exports = __webpack_public_path__ + "static/flags/GI-aa567a9a4b1badaf4c9225eb016040b1.gif";